import { captureMessage } from '@sentry/react';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { client } from '@cast/core';

const COUNTRY_CODE_QUERY_KEY = 'country-code';

const getCountryCodeQueryOptions = ({
  enabled = true,
}: { enabled?: boolean } = {}) =>
  queryOptions({
    queryKey: [COUNTRY_CODE_QUERY_KEY],
    queryFn: async () => {
      const startTime = new Date().getTime();
      const { data } = await client.get('https://api.country.is');
      const endTime = new Date().getTime();
      const duration = endTime - startTime;
      if (duration > 1000) {
        captureMessage(
          `Country code: fetching took over one second (${duration} milliseconds)`
        );
      }
      return data.country || null;
    },
    gcTime: Number.MAX_SAFE_INTEGER,
    enabled,
  });

type UseCountryCodeQuery = {
  country?: string;
  isLoading: boolean;
  error?: any;
};

export const useCountryCodeQuery = (enabled: boolean): UseCountryCodeQuery => {
  const { data, isLoading, error } = useQuery(
    getCountryCodeQueryOptions({ enabled })
  );
  return { country: data || undefined, isLoading, error };
};
